module.exports = __webpack_public_path__ + "static/media/udemy3.b253e56c.png";